import { toAbsoluteUrl } from '~utils/assetsHelpers';
import { PlanFeaturesTypes } from '~globals/types/enums';
import { getLimitPremiunByVersion } from '~utils/feature';

import { DialogExportRouteRoadmapItems } from './types';

export const ITEMS: DialogExportRouteRoadmapItems[] = [
  {
    format: { type: 'table', isExcel: false },
    icon: {
      src: toAbsoluteUrl('/icons/icon_table.svg'),
      alt: 'Export Roadmap Table PDF',
    },
    title: 'Hoja de Ruta (PDF)',
    description: 'Información de cada parada, en formato planilla en PDF.',
  },
  {
    format: { type: 'table', isExcel: true },
    icon: {
      src: toAbsoluteUrl('/icons/icon_table.svg'),
      alt: 'Export Roadmap Table Excel',
    },
    title: 'Hoja de Ruta (Excel)',
    description: 'Información de cada parada, en formato de hoja de cálculo.',
  },
  {
    format: { type: 'details', isExcel: false },
    icon: {
      src: toAbsoluteUrl('/icons/icon_detail.svg'),
      alt: 'Export Roadmap Details',
    },
    title: 'Remitos (PDF)',
    description:
      'Información completa de cada parada y espacio para firma de entrega.',
  },
  {
    format: { type: 'articles', isExcel: true },
    icon: {
      src: toAbsoluteUrl('/icons/icon_detail.svg'),
      alt: 'Export Roadmap Details',
    },
    title: 'Artículos de ruta (Excel)',
    description:
      'Información completa de cada artículo por parada en formato de hoja de cálculo.',
    validSubscriptionFeature: {
      validFeature: PlanFeaturesTypes.LimitPremium,
      availableToDate: getLimitPremiunByVersion('1.22.3'),
    },
  },
];
